export default () => ({
  wallet: null,
  movements: { docs: [], totalDocs: 0, totalPages: 0, page: 1 },
  surveys: [],
  adminSurveys: [],
  eligibility: null,
  sofomes: { docs: [], totalDocs: 0, totalPages: 0, page: 1 },
  rules: [],
  adminWallet: null,
  adminMovements: { docs: [], totalDocs: 0, totalPages: 0, page: 1 },
  loading: false,
  error: null,
});
